
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './past-habits-explanation';
const mainimage = '/Images/habits1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "grammar", subtype: "pasthabits" },
];

const PastHabits = () => (
  <GrammarPageLayout
    level="B1"
    title="Past Habits"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Past Habits and “Used to” Exercises"
    seoDescription="Practice Past Habits with interactive exercises for B2 level English exams."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default PastHabits;

